function sortArticleList() {
    let categoryFilter = document.querySelector(".category-filter");
    let articleList = document.querySelector(".article-list");

    if (articleList && categoryFilter) {
        let articleItems = articleList.querySelectorAll("li");
        let categoryFilterItems = categoryFilter.querySelectorAll("li");

        if (categoryFilterItems.length > 0) {
            categoryFilterItems.forEach((item) => {
                item.addEventListener("click", function (e) {
                    e.preventDefault();

                    categoryFilterItems.forEach((element) => {
                        element.classList.remove("active");
                    });

                    this.classList.add("active");
                    centerActiveTab(this);

                    let currentCategory = this.getAttribute("data-category");

                    if (currentCategory === "all") {
                        articleItems.forEach((element) => {
                            element.style.display = "block";
                        });
                    } else {
                        articleItems.forEach((element) => {
                            element.style.display = "none";
                        });

                        articleList
                            .querySelectorAll(`li.${currentCategory}`)
                            .forEach((element) => {
                                element.style.display = "block";
                            });
                    }
                });
            });
        }
    }
}

sortArticleList();
